export default __webpack_public_path__ + "static/media/inex_white.13453643.png";